import React from "react";
import { Box, Typography } from "@mui/material";
import { styles } from "./DataTable.styles";

const ColorLegend = ({ legendText, legendColor }) => {
  return (
    <Box sx={styles.legendContainer}>
      {legendText.map((text, index) => (
        <Box key={text} sx={styles.legendItem}>
          <Box sx={{ ...styles.legendColorBox, ...legendColor[index] }} />
          <Typography sx={styles.legendText}>{text}</Typography>
        </Box>
      ))}
    </Box>
  );
};

export default ColorLegend;
